import React from 'react'
import GlobalDialog from './GlobalDialog'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { ApproveButton, CancelButton, DeleteButton, RejectButton } from '../Buttons/Buttons'

export default function GlobalReject({
  api,
  loading,
  title,
  displayNote,
  upDateCall,
  buttonName,
  otherActions,
  disabled,
  updatePaginationCall,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <GlobalDialog
        title={title ? title : 'Action'}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={'xs'}
        popupButton={
          <RejectButton
            disabled={disabled}
            size="small"
            action={() => {
              setOpen(true)
            }}>
            {buttonName?buttonName:'Reject'}
          </RejectButton>
        }
        content={
          <>
            <Typography>{displayNote ?displayNote :"Are you sure you want to proceed with this action?"}</Typography>
          </>
        }
        actionButton={
          <>
            <CancelButton
              action={() => {
                setOpen(false)
              }}>
              Cancel
            </CancelButton>
            <RejectButton
              action={() => {
                dispatch(api).then((res) => {
                  if (res.payload.status === 'failed' || res.payload.status === 'error') {
                    setOpen(false)
                    enqueueSnackbar(res.payload.message, {
                      variant: 'error',
                    })
                  } else if (res.payload.status === 'success') {
                    dispatch(upDateCall)
                    if (otherActions) {
                        otherActions(false);
                      }
                    if (updatePaginationCall) {
                      dispatch(updatePaginationCall)
                    }
                    setOpen(false)
                    // otherActions(false);
                    enqueueSnackbar(res.payload.message, {
                      variant: 'success',
                    })
                  }
                })
              }}>
              {loading ? "Submitting..." : buttonName?buttonName:'Reject'}
            </RejectButton>
          </>
        }
      />
    </div>
  )
}
